import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmQueuesNewRoute: InvariantJiraRoute = {
	name: 'csm-queues-new',
	path: '/jira/customer-service-management/projects/:projectKey/queues/custom/new',
	query: ['parentId?'],
	exact: true,
};
